<template lang="pug">
nav#site-nav
  router-link(:to="{ name: 'defaultScene', params: { path: '/' }}" class="brand logo")
  div#localeSelect
    span.button.minimal(v-on:click="switchLocale('nl-NL')" :class="this.currentLocale === 'nl-NL' ? 'active' : 'inactive'") NL
    span.button.minimal(v-on:click="switchLocale('en-US')" :class="!this.currentLocale || this.currentLocale === 'en-US' ? 'active' : 'inactive'") EN
  //- div.nav-items-container
  //-   //- .button.icon.close-icon.close-nav close
  //-   ol.nav-items
  //-     li(v-for="(n, i) in filteredPages" class="item button" v-bind:css="true" :key="'nav_item' + i")
  //-       router-link(:to="{ name: 'pageScene', params: { page: n.slug }}") {{ n.title }}
</template>

<script>
import Vue from 'vue'
import { mapGetters, mapActions } from 'vuex'
import anime from 'animejs'

// Storing animation target elements
const animTargets = {
  container: '#container'
}

// component instance
var Navigation = Vue.component('navigation', {
  name: 'Navigation',
  props: [''],
  data: function () {
    return {
      state: {
      }
    }
  },
  watch: {
    'pages': function () {
      console.log(this.currentLocale)
      // console.log(this.pages)
    }
  },
  methods: {
    ...mapActions([
      'getEntry',
      'updateCurrentLocale'
    ]),
    switchLocale (locale) {
      console.log('switching locale to ' + locale)
      this.updateCurrentLocale(locale)
    }
  },
  computed: {
    filteredPages () {
      let filtered = {}

      for (var n in this.pages) {
        // console.log(n)
        this.pages[n].navigation && Vue.set(filtered, this.pages[n].slug, this.pages[n])
      }

      return filtered
    },
    ...mapGetters([
      'domain',
      'pages',
      'currentLocale'
    ]),
    actions () {
      // let component = this

      return {
        SET: () => {
          return anime({
            targets: animTargets.container + this._uid,
            easing: 'easeInOutQuad',
            opacity: [
              { value: '1' }
            ],
            translateX: [
              { value: 0 }
            ],
            translateY: [
              { value: 0 }
            ],
            borderColor: [
              { value: '#F0F0F0' }
            ],
            boxShadow: [
              { value: '0px 0px 10px rgba(211,211,211,1)' }
            ],
            duration: 200,
            begin: function (e) {
              console.log('set')
            },
            complete: function () {
            }
          })
        }
      }
    }
  },
  created () {
  },
  mounted () {
  },
  beforeCreate () {
  },
  beforeUpdate () {
  },
  beforeDestroy () {
  }
})

// export component
export default Navigation
</script>

<style lang="scss" scoped>
  #localeSelect{
    position: absolute;
    right: $body-gutter;
    margin-top: .4rem;

    .button{
      font-weight: 400;
      // border: 1px solid $primary-color;
      border-radius: 0;

      &.active{ font-weight: 700; color: get-color(primary)}
      &.inactive{ color: $medium-gray; border-bottom-color: $medium-gray}

      &:hover{ border-bottom-color: get-color(primary); color: get-color(primary-plus1)}
    }
  }
  nav#site-nav{
    position: absolute;
    top: 2.1rem;
    left: 0;
    width: 100%;
    height: 100px;

    .nav-items-container{
      display: flex;
      flex-grow: 1;
      flex-direction: column;
      align-items: flex-end;
      flex-wrap: nowrap;
      // flex-flow: column no-wrap;
    }

    .logo{
      margin-left: $body-gutter;
    }

    ol, ul, .nav-items{

      margin-right: $body-gutter;

      li, li.item{
        // float: left;
        &.button{
          background: $white;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Navigation.vue